class StarRating extends window.BAO.CustomElement() {
  static observedAttributes = ['data-rating-summary']

  connectedCallback () {
    super.connectedCallback()

    this.reviewRating = ''
    this.reviewCount = ''

    this.initiateUpdate()
  }

  attributeChangedCallback () {
    this.initiateUpdate()
  }

  initiateUpdate () {
    const ratingSummary = JSON.parse(this.dataset.ratingSummary)

    this.innerHTML = ''

    if (ratingSummary) {
      this.reviewRating = ratingSummary.reviewAverageValue
      this.reviewCount = ratingSummary.reviewCount

      if (ratingSummary.reviewCount > 0) {
        this.appendAccessText()
        this.updateStars()
        this.appendCount()
      }
    }
  }

  appendAccessText () {
    const accessDiv = document.createElement('div')
    accessDiv.classList.add('sec-Star_Rating-access')
    accessDiv.innerHTML = `Average rating ${this.reviewRating} out of 5, from ${this.reviewCount} reviews`
    this.appendChild(accessDiv)
  }

  updateStars () {
    for (let i = 0; i < 5; i++) {
      if (i < this.reviewRating) {
        this.appendStar((this.reviewRating - i).toFixed(1))
      }
    }
  }

  appendStar (strength) {
    const newStar = document.createElement('span')
    newStar.classList.add('sec-Star_Rating-star')
    newStar.innerHTML = '★'
    if (strength >= 1) {
      newStar.style.setProperty('--star-strength', 1)
    } else {
      newStar.style.setProperty('--star-strength', strength)
    }
    this.appendChild(newStar)
  }

  appendCount () {
    const countDiv = document.createElement('div')
    countDiv.classList.add('sec-Star_Rating-count')
    countDiv.innerHTML = `(${this.reviewCount})`
    this.appendChild(countDiv)
  }
}

if (!customElements.get('star-rating')) {
  customElements.define('star-rating', StarRating)
}
